export const PATH_URL = {
   LOGIN: '/login',
   TERMS: '/terms',
   POLICY: '/policy',
   POLICY_VTICKET: '/policy-vticket',
}